module.exports = __webpack_public_path__ + "assets/img/3beae7293a82c5f3e532ecaeab08b590.png";